import React from 'react';
import {Card, Layout} from 'antd';
import AnyChart from 'anychart-react';

import ExposureTable from "./ExposureTable";
import NivoBarChart from "../../../charts/nivo/NivoBarChart";
import {mapExposureColor, findMaximumExposures} from "./utils";
import { chartBaseJsonConfig, scatterConfigJson } from '../../../charts/configJson';



const ExposureBubbleChart = ({ maxExposureData, currentWeights }) => {
  const scatterData = maxExposureData.map(item => ({
    x: currentWeights[item.x.toLowerCase()] * 100, // assuming currentWeights are fractions
    value: parseFloat(item.value),
    name: item.x,
    fill: mapExposureColor(item.value),
    stroke: mapExposureColor(item.value),
    markerSize: 15

  }));

  let scatterChartSettings = {
    type: 'scatter',
    data: scatterData,
    yAxis: {
      title: 'Max Exposure (%)',
    },
    xAxis: {
      title: 'Current Exposure (%)'
    },
    height: '600px',
    ...scatterConfigJson.apply()
    // Configure other chart settings as needed
  };
  scatterChartSettings = chartBaseJsonConfig.applyBaseConfig(scatterChartSettings);
  return <AnyChart id={'scatter-chart-exposure-chart'} {...scatterChartSettings} />;
};




const ExposureBarChart = ({ maxExposureData }) => {
    let colors = {}
    const barChartData = maxExposureData.map(item => {
        colors[item.x] = mapExposureColor(item.value)
        return {id: item.x, [item.x]: parseFloat(item.value)}
  });
  const keys = maxExposureData.map(item => item.x);

  return (
      <div style={{height: 300, width: '100%'}}>
        <NivoBarChart
            data={barChartData}
            keys={keys}
            customColors={colors}
            vertical={true}
            barPadding={0.3}
            rotateLabels={90}
            mode={'stacked'}
            legendSize={'small'}
            borderRadius={4}
        />
      </div>
  )

};


const MaxExposure = ({ treeData, symbols }) => {
  const maxExposureData = findMaximumExposures(treeData);
  const currentWeights = symbols;

  return (
    <Layout>
        <Layout.Sider style={{background: "#fff"}} width={500}>
            <ExposureTable maxExposureData={maxExposureData} currentWeights={currentWeights} />
        </Layout.Sider>
        <Layout.Content>
            <div style={{maxWidth: 1000, margin: 'auto'}}>
                <Card bordered={false}>
                    <ExposureBarChart maxExposureData={maxExposureData} />
                </Card>
                <div style={{height: '300px', width: '100%'}}>
                    <ExposureBubbleChart maxExposureData={maxExposureData} currentWeights={currentWeights} />
                </div>
            </div>
        </Layout.Content>
    </Layout>
  );
};

export default MaxExposure;